import {resolveBackground} from '#core/utils/color-utils.js';

import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import PALETTE_SCHEMA from './scoreboards.palette-schema.yaml';

class ScoreboardsFactory extends AbstractVisualFeature {
    get name() {
        return 'Scoreboards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        const {FONT_FAMILY, FONT_WEIGHT_SEMI_BOLD, FONT_WEIGHT_BOLD, SEPARATOR_COLOR} = PALETTE;

        const SCOREBOARD_CONTAINER_STYLES = {
            style: {
                ...resolveBackground(PALETTE.SCOREBOARD_CONTAINER_BG),
                fontFamily: FONT_FAMILY,
                _desktop_boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
                borderRadius: 8,
                overflow: 'hidden',
                textAlign: 'center',
            },
        };
        const INPLAY_CLOCK = {
            timerFiveDigits: {
                timePart: {
                    style: {
                        fontSize: 12,
                        ...PALETTE.TIMING_STATUS_LABEL.EVENT_TIMING_LIVE_TEXT,
                    },
                },
            },
            timerFourDigits: {
                timePart: {
                    style: {
                        fontSize: 12,
                        ...PALETTE.TIMING_STATUS_LABEL.EVENT_TIMING_LIVE_TEXT,
                    },
                },
            },
        };
        const result = {
            Scoreboard: {
                content: SCOREBOARD_CONTAINER_STYLES,
                backgroundImages: {
                    football: 'card-background/scoreboard_bg_football.png',
                    winter_sport: 'card-background/scoreboard_bg_wintersports.png',
                    motorcycling: 'card-background/scoreboard_bg_motor_sports.png',
                },
                container: {
                    style: {
                        borderRadius: '8px',
                    },
                },
            },
            PreplayScoreboard: {
                container: SCOREBOARD_CONTAINER_STYLES,
                dateTimeWrapper: {
                    style: {
                        fontFamily: FONT_FAMILY,
                        fontSize: 12,
                        ...PALETTE.TIMING_STATUS_LABEL.EVENT_TIMING_UPCOMING_TEXT,
                    },
                },
            },
            ScoreboardContentBase: {
                accentColor: PALETTE.ACCENT_COLOR,
                primaryColor: PALETTE.PRIMARY_COLOR,
                secondaryColor: PALETTE.SECONDARY_COLOR,
            },
            GenericInplayScoreboard: {
                // container: {
                //     style: {
                //         boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.3)'
                //     }
                // }
                inPlayClock: INPLAY_CLOCK,
                container: SCOREBOARD_CONTAINER_STYLES,
                style: {
                    // text for scores '1' '5' -> 1 | 5'
                    score: {
                        fontSize: 18,
                        fontWeight: FONT_WEIGHT_BOLD,
                        ...PALETTE.SCORE_TEXT,
                    },
                    scoreSeparator: {
                        color: PALETTE.TEAM_SEPARATOR_COLOR,
                    },
                    participantName: {
                        fontSize: 14,
                        fontWeight: FONT_WEIGHT_SEMI_BOLD,
                        ...PALETTE.PARTICIPANT_NAME_TEXT,
                    },
                    // segment text  '1H' '45'' ->  1H | 45'
                    // what the heck it is called segment text - ask mojito
                    segmentData: {
                        fontSize: 12,
                        ...PALETTE.TIMING_STATUS_LABEL.EVENT_TIMING_LIVE_TEXT,
                    },
                },
                // separator for scores '|' -> 1 | 5'
                scores: {
                    separator: {
                        style: {
                            color: SEPARATOR_COLOR,
                            margin: '8px 0',
                        },
                    },
                },
                // segments info separator '|' -> 1H | 45'
                segmentsInfo: {
                    separator: {
                        style: {
                            color: SEPARATOR_COLOR,
                        },
                    },
                },
            },
            OutrightScoreboard: {
                container: SCOREBOARD_CONTAINER_STYLES,
                eventName: {
                    style: {
                        fontWeight: FONT_WEIGHT_SEMI_BOLD,
                        ...PALETTE.PARTICIPANT_NAME_TEXT,
                    },
                },
            },
            SegmentBasedInplayScoreboard: {
                container: SCOREBOARD_CONTAINER_STYLES,
                style: {
                    eventInfoHeaderCell: {
                        // what the heck it is called header cell when it is not
                        fontSize: 12,
                        ...PALETTE.TIMING_STATUS_LABEL.EVENT_TIMING_LIVE_TEXT,
                    },
                    serverDataCell: {
                        fontSize: 8,
                    },
                    segmentDataCell: {
                        fontWeight: 'normal',
                        fontSize: 14,
                        ...PALETTE.SEGMENT_TEXT,
                    },
                    totalsHeaderCell: {
                        fontSize: 12,
                        ...PALETTE.SEGMENT_TOTAL_HEADER_TEXT,
                    },
                    totalsDataCell: {
                        fontSize: 16,
                        fontWeight: FONT_WEIGHT_BOLD,
                        ...PALETTE.SEGMENT_TOTAL_TEXT,
                    },
                    segmentHeaderCell: {
                        fontSize: 12,
                        ...PALETTE.SEGMENT_HEADER_TEXT,
                    },
                    currentSegmentHeaderCell: {
                        fontSize: 12,
                        ...PALETTE.SEGMENT_HEADER_TEXT,
                    },
                    currentSegmentDataCell: {
                        fontWeight: 'normal',
                        fontSize: 14,
                        ...PALETTE.SEGMENT_TEXT,
                    },
                },
                eventInfoDataCell: {
                    style: {
                        fontSize: 14,
                        fontWeight: FONT_WEIGHT_SEMI_BOLD,
                        ...PALETTE.PARTICIPANT_NAME_TEXT,
                    },
                },
                eventInfoColumn: {
                    style: {
                        alignItems: 'flex-start',
                    },
                },
            },
            CricketScoreboard: {
                segmentBasedInplayScoreboard: {
                    container: {
                        style: {
                            padding: 8,
                        },
                    },
                    dataRowHeight: '24px',
                    headerRowHeight: '16px',
                },
            },
            ParticipantsBoard: {
                style: {
                    teamName: {
                        ...PALETTE.PARTICIPANT_NAME_TEXT,
                    },
                    teamNameSeparator: {
                        color: PALETTE.TEAM_SEPARATOR_COLOR,
                    },
                },
            },
        };

        return result;
    }
}

new ScoreboardsFactory(allVisuals);
